import Grid from '@material-ui/core/Grid';
import { FiXCircle } from 'react-icons/fi';
import "./ButtonClosedCardContent.css";

const ButtonClosedCardContent = ({ onHandleClasses }) => {
    return(
      <Grid item container justifyContent="center" alignItems="center">
        <div 
          className="button-closed-card-content" 
          onClick={()=>onHandleClasses("remove")}>
          <FiXCircle size={"25px"}/>
        </div>
      </Grid>
    );
}

export default ButtonClosedCardContent;

//los botones son div xq ProjectFrame contiene todo sus childrens en un button, y si hay botones dentro de botones aparecen warnings 🤷‍♂️